/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, signal, Output, EventEmitter, input, effect } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { DesyAngularModule } from 'desy-angular';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { getError } from '@/app/utils/form-errors';
import { AiSystemDeployment, Step3Deployment } from '@/app/interfaces/aiSystemDeployment';

@Component({
  selector: 'app-deploy-system-of-ia-step-3',
  templateUrl: './deploy-system-of-ia-step-3.component.html',
  styleUrls: ['./deploy-system-of-ia-step-3.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AutoCompleteModule,
    ButtonsComponent,
    DesyAngularModule,
    DatePickerModule,
    SelectButtonModule,
    MultiSelectModule,
  ],
  providers: [ConfirmationService],
})
export class DeploySystemOfIaStep3Component {
  @Output() stepCompleted = new EventEmitter<Step3Deployment>();
  @Output() goToPreviousStep = new EventEmitter<Step3Deployment | null>();

  existingData = input<Partial<AiSystemDeployment>>();

  form: FormGroup;
  getError = getError;

  dataCategoryOptions = [
    {
      label: 'Datos personales',
      value: 'personales',
    },
    {
      label: 'Datos personales sensibles',
      value: 'sensibles',
    },
    {
      label: 'Datos anonimizados',
      value: 'anonimizados',
    },
    {
      label: 'Datos seudonimizados',
      value: 'seudonimizados',
    },
    {
      label: 'Datos administrativos',
      value: 'administrativos',
    },
    {
      label: 'Datos transaccionales',
      value: 'transaccionales',
    },
    {
      label: 'Datos sintéticos',
      value: 'sinteticos',
    },
    {
      label: 'Datos textuales o no estructurados',
      value: 'noEstructurados',
    },
    {
      label: 'Datos multimedia',
      value: 'multimedias',
    },
    {
      label: 'Metadatos',
      value: 'metadatos',
    },
  ];

  formSubmitted = signal(false);
  highRiskFieldsRequired = signal(false);

  constructor(
    private fb: FormBuilder,
    private router: Router
  ) {
    this.form = this.fb.group({
      aiInfrastructure: [null, Validators.maxLength(200)],
      integrationMode: [null, Validators.maxLength(500)],
      dataSource: [null, Validators.maxLength(500)],
      timePeriod: [null, Validators.maxLength(200)],
      dataCategory: [[null], Validators.required],
      qualityAccreditation: null,
      inputDataSource: [null, Validators.maxLength(500)],
      sourceCode: [null, Validators.maxLength(200)],
    });

    effect(() => {
      const data = this.existingData();
      if (data) {
        this.form.patchValue(data);
      }
      const isHighRisk = data.systemClassification === 'alto';
      this.highRiskFieldsRequired.set(isHighRisk);
      if (isHighRisk) {
        const fields = ['dataSource', 'timePeriod', 'qualityAccreditation', 'inputDataSource', 'sourceCode'];
        fields.forEach((field) => {
          const control = this.form.get(field);
          control?.addValidators(Validators.required);
          control?.updateValueAndValidity();
        });
      }
    });
  }

  async onSave() {
    const formData = this.form.value;
    this.stepCompleted.emit(formData);
  }

  backPage(): void {
    const formData = this.form.value;
    this.goToPreviousStep.emit(formData);
  }

  cancel(): void {
    this.router.navigate([`/catalogo-ia/sistemas-de-ia/listado-sistemas`]);
  }

  confirm() {
    this.formSubmitted.set(true);
    this.onSave();
  }
}
